import React, { useContext } from "react";

//Style
import { makeStyles } from "@material-ui/core/styles";

//Component
//--> Drawer
import SideDrawer from "../../components/Drawer/SideDrawer";
//--> Cover
import Cover from "../../components/Cover/Cover";
//--> Cover
import { Info } from "../../components/Alert/Alert";
//--> Feeds
import Feeds from "../../components/Forms/Feeds";
//--> Title
// import Title from "../../components/Title";

//Context
import { FeedbackContext } from "../../context/FeedbackContext";

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  toolbar: theme.mixins.toolbar,
}));

function Feedback() {
  const classes = useStyles();

  //Context
  const { feedbacks } = useContext(FeedbackContext);

  return (
    <div style={{ display: "flex", backgroundColor: "#F3F4F7" }}>
      <SideDrawer />
      <div style={{ flex: 1 }}>
        <div className={classes.toolbar} />
        <Cover title="Agents Feedback" />
        <div className={classes.content}>
          <div
            style={{
              display: "flex",
              flexFlow: "row wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {feedbacks.length !== 0 ? (
              feedbacks.map((data) => {
                return <Feeds data={data} />;
              })
            ) : (
              <Info
                title="Generate Feedback"
                msg="There is no feedback generated by your team."
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feedback;
